var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.17725 7.11001L2.02156 12.27C1.86169 12.43 1.66852 12.51 1.44205 12.51C1.21557 12.51 1.01573 12.43 0.842546 12.27C0.669358 12.11 0.582764 11.91 0.582764 11.67C0.582764 11.43 0.676019 11.23 0.86253 11.07L5.41872 6.51001L0.86253 1.95001C0.676019 1.79001 0.582764 1.59001 0.582764 1.35001C0.582764 1.11001 0.669358 0.91001 0.842546 0.75001C1.01573 0.59001 1.21557 0.51001 1.44205 0.51001C1.66852 0.51001 1.86169 0.59001 2.02156 0.75001L7.17725 5.91001C7.36376 6.07001 7.45702 6.27001 7.45702 6.51001C7.45702 6.75001 7.36376 6.95001 7.17725 7.11001Z",
    fill: "#050B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrow);
export default __webpack_public_path__ + "static/media/rightarrow.0fc1471448c1ae510d32784fd755f187.svg";
export { ForwardRef as ReactComponent };